import React from "react";
import classes from "./Personal.module.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import ContentWrapper from "../../wrappers/ContentWrapper/ContentWrapper";
import { Outlet } from "react-router-dom";

const Personal = () => {
    return (
        <ContentWrapper className={classes.adminWrapper}>
            <div className={classes.admin}>
                <Sidebar />
                <div>
                    <Outlet />
                </div>
            </div>
        </ContentWrapper>
    );
};

export default Personal;
